import React from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import ArrowEndDownIcon from '@offerzen/zenicon/ArrowEndDownIcon'
import CloseIcon from '@offerzen/zenicon/CloseIcon'
import AccessibleIcon from '../AccessibleIcon'

import styles, { wrapperTheme, wrapperSize, labelSize, iconColor, iconSize } from './styles'

const Attachment = ({ name, url, theme, size, onClear, className, onDownload }) => (
  <div className={cx(styles.wrapper, className, wrapperTheme(theme), wrapperSize(size))}>
    {url && !onClear ? (
      <a href={url} download={name} onClick={onDownload} rel="noopener noreferrer" target="_blank" className={styles.link}>
        <span className={cx(styles.label, labelSize(size))}>{name}</span>
        <span className={styles.icon}>
          <AccessibleIcon icon={ArrowEndDownIcon} size={iconSize(size)} color={iconColor(theme)} />
          <span className={styles.accessiblyHidden}>Download</span>
        </span>
      </a>
    ) : (
      <>
        <span className={cx(styles.label, labelSize(size))}>{name}</span>
        {Boolean(url) && (
          <a href={url} download={name} rel="noopener noreferrer" target="_blank" className={styles.icon}>
            <AccessibleIcon icon={ArrowEndDownIcon} size={iconSize(size)} color={iconColor(theme)} />
            <span className={styles.accessiblyHidden}>Download</span>
          </a>
        )}
        {Boolean(onClear) && (
          <button type="button" onClick={onClear} className={styles.icon}>
            <AccessibleIcon icon={CloseIcon} size={iconSize(size)} color={iconColor(theme)} />
            <span className={styles.accessiblyHidden}>Clear</span>
          </button>
        )}
      </>
    )}
  </div>
)

Attachment.propTypes = {
  name: PropTypes.string.isRequired,
  url: PropTypes.string,
  theme: PropTypes.oneOf(['', 'primary', 'secondary', 'success', 'warning', 'error', 'legacy', 'light', 'dark', 'tertiary', 'info']),
  size: PropTypes.oneOf(['', 'default', 'small']),
  onClear: PropTypes.func,
  onDownload: PropTypes.func,
  className: PropTypes.string,
}

Attachment.defaultProps = {
  theme: 'primary',
  size: 'default',
}

export default Attachment
